exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#duplicateDeliverableDetailModal___BV_modal_content_{padding:16px}.edit-deliverable-modal-pop .modal-dialog{max-width:90vw}.edit-deliverable-modal-pop .modal-body{padding:24px 28px}.dup-preview-description{max-height:300px;overflow-y:auto;padding:8px;border:1px solid #eee;border-radius:4px;background:#fafafa}", ""]);

// exports
